/* eslint-disable new-cap */
import {FacetRangeslider} from 'extensions/facet-rangeslider/lib/facet-rangeslider';

const getKey = (index, length) => {
	if (index === 0) {
		return 'min';
	}
	else if (index === length - 1) {
		return 'max';
	}

	return `${Math.round(index / (length - 1) * 100)}%`;
};

const numericSort = (a, b) => a - b;

export class CheckboxRangeslider extends FacetRangeslider {
	static get styles () {
		return [...super.styles];
	}

	static get properties () {
		return {
			...super.properties,
			unit: {
				type: String
			},
			values: {
				type: Array
			}
		};
	}

	get sliderFormat () {
		return {
			from: value => {
				return value;
			},
			to: value => {
				return `${value}${this.unit ? ' ' + this.unit : ''}`;
			}
		};
	}

	get parsedValues () {
		return this.values.map(value => parseFloat(value.value)).sort(numericSort);
	}

	get high () {
		return this.parsedValues[this.parsedValues.length - 1];
	}

	get low () {
		return this.parsedValues[0];
	}

	get activeHigh () {
		let filters = [...this.values];
		const activeFilters = filters.filter((v) => v.selected);
		if (activeFilters.length) {
			filters = [...activeFilters];
		}

		filters = filters.map(value => parseFloat(value.value)).sort(numericSort);
		return filters.pop();
	}

	get activeLow () {
		let filters = [...this.values];
		const activeFilters = filters.filter((v) => v.selected);
		if (activeFilters.length) {
			filters = [...activeFilters];
		}

		filters = filters.map(value => parseFloat(value.value)).sort(numericSort);
		return filters[0];
	}

	get sliderOptions () {
		return {
			ariaFormat: this.sliderFormat,
			connect: true,
			format: this.sliderFormat,
			handleAttributes: [
				{
					'aria-label': `Minimum ${this.prompt}`
				},
				{
					'aria-label': `Max ${this.prompt}`
				}
			],
			range: this.parsedValues.reduce((o, value, index, arr) => {
				const key = getKey(index, arr.length);
				return {
					...o,
					[key]: [parseFloat(value)]
				};
			}, {}),
			snap: true,
			start: [
				this.activeLow,
				this.activeHigh
			]
		};
	}

	firstUpdated () {
		super.firstUpdated();

		// Set initial values that are selected for the form element
		this.setFormValue(this.values.filter(value => value.selected));
	}

	handleChange (formattedValues, handleNumber, [
		low,
		high
	]) {
		if (low === this.activeLow && high === this.activeHigh) {
			return;
		}

		const selectValues = this.values.filter(value => value.value >= low && value.value <= high);

		if (low === this.low && high === this.high) {
			this._internals.setFormValue('');
		} else {
			this.setFormValue(selectValues);
		}

		this._internals?.form?.submit();
	}

	setFormValue (values = this.values) {
		const facetForm = new FormData();
		for (let value of values) {
			facetForm.append(this.code, value.prompt.toString().replace(` ${this.unit}`, ''));
		}

		this._internals.setFormValue(facetForm);
	}
};

window.customElements.define('x-checkbox-rangeslider', CheckboxRangeslider);
